import { JobStartedModel } from "./JobStartedModel";
import { JobStartedService } from "./JobStartedService";

export class ISiteMobileJobIndexPage {
    private jobSrv: JobStartedService = new JobStartedService();
    constructor() { }

    public Init() {
        this.getLocalJobs();
        $('#post-jobs').click( () => this.postLocalJobs() );
        $('#local-save-job').click(() => this.saveJobLocal() );
        $('#start-job').click( () => this.postJobStarted() );
    }

    private getLocalJobs() {
        this.jobSrv.GetJobsStartedQueue(function (data: any) {
            let savedjobsHtml = '';
            for (let i = 0; i < data.length; i++) {
                savedjobsHtml += '<div class="row"><div class="col-4">' + data[i].Id + '</div><div class="col-8">' + data[0].StartedOn + '</div></div>';
            }

            $('#saved-jobs').html(savedjobsHtml);
        });
    }

    private postLocalJobs() {
        this.jobSrv.ProcessJobStartedQueue(function (isPosted:boolean) {
            if (isPosted) location.reload();
        });
    }

    private saveJobLocal() {
        if (!isNaN(Number($('#id-local-job').val()))) {
            const id = Number($('#id-local-job').val());
            $('.required').removeClass('required');

            if (!(Number.isInteger(Number(id)) && Number(id) > 0)) {
                $('#id-local-job').addClass('required');
                return;
            }

            const startedOn = (new Date()).toJSON();
            const jobStarted: JobStartedModel = { Id: id, StartedOn: startedOn };
            this.jobSrv.AddJobStartedToQueue(jobStarted, function () {
                location.reload();
            });
        }
    }

    private postJobStarted() {
        if (!isNaN(Number($('#id-start-job').val()))) {
            const id = Number($('#id-start-job').val());
            $('.required').removeClass('required');

            if (!(Number.isInteger(Number(id)) && Number(id) > 0)) {
                $('#id-start-job').addClass('required');
                return;
            }

            this.jobSrv.SetJobStarted(id, function () {
                location.reload();
            });
        }
    }
    
}
 